import { Typography, useToast } from "@codat/orchard-ui";
import classNames from "classnames";
import React from "react";

import ClipboardCopy from "components/ClipboardCopy";

import styles from "./IdCell.module.css";

interface IdCellProps {
  value: {
    id: string;
    name: string;
    copySuccessMessage: string;
    clipboardClassName: string;
    ["data-testid"]?: string;
  };
}

export const IdCell: React.FC<IdCellProps> = ({
  value: {
    id,
    ["data-testid"]: dataTestId,
    name,
    copySuccessMessage,
    clipboardClassName,
  },
}) => {
  const { addToast } = useToast();

  return (
    <div className={classNames(styles.cell)}>
      <Typography as="div" variant="p" data-testid={dataTestId}>
        {`${id.substring(0, 8)}...${id.substring(id.length - 9)}`}
        <ClipboardCopy
          dataTestId={`${dataTestId}-clipboard-copy`}
          clipboardName={name}
          text={id}
          onCopy={() => {
            addToast({
              message: copySuccessMessage,
              variant: "success",
            });
          }}
          noBackground
          color="interface"
          className={classNames(styles.clipboard, clipboardClassName)}
          iconClassName={styles.clipboardIcon}
        />
      </Typography>
    </div>
  );
};
